import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import EditCard from '../../../../Modals/EditCardModal/EditCard';
import FollowIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import WatchIcon from '@mui/icons-material/AccessTimeOutlined';
import DescriptiondIcon from '@mui/icons-material/DescriptionOutlined';
import CommentIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import CheckIcon from '@mui/icons-material/LibraryAddCheckOutlined';
import AttachmentIcon from '@mui/icons-material/InsertLinkRounded';
import {
	AttachmentContainer,
	CardTitle,
	CommentContainer,
	Container,
	Cover,
	DateContainer,
	FooterContainer,
	IconGroupContainer,
	IconGroupWrapper,
	IconWrapper,
	Label,
	LabelContainer,
	Span,
	CheckContainer,
	MembersContainer,
	MembersWrapper,
} from './styled';
import { Draggable } from 'react-beautiful-dnd';
import moment from 'moment';
import { Avatar } from '@mui/material';
const Card = (props) => {
	const location = useLocation();
	const history = useHistory()
	const [openModal, setOpenModal] = useState(false);
	const card = props.info;
	const comment = card.activities.filter((act) => act.isComment).length;
	let checks = { c: 0, n: 0 };
	card.checklists.map((checklist) => {
		return checklist.items.map((item) => {
			if (item.completed) checks.c += 1;
			else checks.n += 1;
			return item;
		});
	});
	let labels = card.labels.filter((i) => i.selected);
	const handleOpenClose = () => {
		if (!openModal) history.push(`${location.pathname}?cardId=${props.info._id}`);
		else history.push(`${location.pathname}`);
		setOpenModal(!openModal);
	};

	useEffect(() => {
		if (props.cardId === props.info._id) {
		  setOpenModal(true);
		}
	  }, [props.cardId, props.info._id]);

	const formatDate = (date) => {
		if (moment(date).toDate().getFullYear() < new Date().getFullYear()) return moment(date).format('MMM DD, yyyy');
		else return moment(date).format('MMM DD');
	};

	function getStyle(style, snapshot) {
		if (!snapshot.isDropAnimating) {
			return style;
		}
		return {
			...style,
			transitionDuration: `80ms`,
		};
	}

	return (
		<>
			<Draggable draggableId={props.info._id} index={props.index}>
				{(provided, snapshot) => {
					return (
						<Container
							onClick={handleOpenClose}
							{...provided.dragHandleProps}
							{...provided.draggableProps}
							style={getStyle(provided.draggableProps.style, snapshot)}
							ref={provided.innerRef}
							isDragging={snapshot.isDragging}
							color={!card.cover.isSizeOne ? card.cover.color : 'var(--surface-white)'}
							padding={card.cover.color && card.cover.isSizeOne}
						>
							{card.cover.isSizeOne && <Cover color={card.cover.color} />}
							{labels && (
								<LabelContainer>
									{labels.map((label) => {
										return <Label key={label._id} color={label.color} />;
									})}
								</LabelContainer>
							)}

							<CardTitle>{card.title}</CardTitle>
							<FooterContainer>
								<IconGroupContainer>
									<IconGroupWrapper>
										{card.watchers.length > 0 && (
											<IconWrapper>
												<FollowIcon fontSize='0.5rem' />
											</IconWrapper>
										)}
										{card.attachments.length > 0 && (
											<AttachmentContainer>
												<AttachmentIcon fontSize='small' />
												<Span>{card.attachments.length}</Span>
											</AttachmentContainer>
										)}

										{(card.date.dueDate || card.date.startDate) && (
											<DateContainer
												backColor={
													card.date.completed
														? 'var(--teal)'
														: moment(card.date.dueDate).toDate().getTime() <
														  new Date().getTime()
														? 'rgba(247, 111, 111, 0.55)'
														: 'transparent'
												}
												hoverBg={
													card.date.completed
														? 'var(--teal)'
														: moment(card.date.dueDate).toDate().getTime() <
														  new Date().getTime()
														? 'var(--coral)'
														: 'rgba(26, 35, 64, 0.14)'
												}
												color={
													card.date.completed ||
													moment(card.date.dueDate).toDate().getTime() < new Date().getTime()
														? 'var(--surface-white)'
														: 'var(--text-muted)'
												}
											>
												<WatchIcon
													style={{
														color:
															card.date.completed ||
															moment(card.date.dueDate).toDate().getTime() <
																new Date().getTime()
																? 'var(--surface-white)'
																: 'var(--text-muted)',
													}}
													fontSize='0.5rem'
												/>
												<Span
													color={
														card.date.completed ||
														moment(card.date.dueDate).toDate().getTime() <
															new Date().getTime()
															? 'var(--surface-white)'
															: 'var(--text-muted)'
													}
												>{`${card.date.startDate ? formatDate(card.date.startDate) : ''}${
													card.date.startDate ? (card.date.dueDate ? ' - ' : '') : ''
												}${card.date.dueDate ? formatDate(card.date.dueDate) : ''}${
													card.date.dueTime ? ' at ' + card.date.dueTime : ''
												}`}</Span>
											</DateContainer>
										)}
										{card.description && <DescriptiondIcon fontSize='0.5rem' />}
										{comment > 0 && (
											<CommentContainer>
												<CommentIcon fontSize='0.5rem' />
												<Span>{comment}</Span>
											</CommentContainer>
										)}
										{card.checklists.length > 0 && (
											<CheckContainer>
												<CheckIcon fontSize='0.5rem' />
												<Span>
													{checks.c}/{checks.c + checks.n}
												</Span>
											</CheckContainer>
										)}
									</IconGroupWrapper>
								</IconGroupContainer>
								{card.members && (
									<MembersContainer>
										<MembersWrapper>
											{card.members &&
												card.members.map((member, i) => {
													return (
														<Avatar
															key={i}
															sx={{
																width: 28,
																height: 28,
																bgcolor: member.color,
																fontSize: '0.875rem',
																fontWeight: '800',
															}}
														>
															{member.name[0].toUpperCase()}
														</Avatar>
													);
												})}
										</MembersWrapper>
									</MembersContainer>
								)}
							</FooterContainer>
						</Container>
					);
				}}
			</Draggable>
			{openModal && (
				<EditCard
					open={openModal}
					callback={handleOpenClose}
					ids={{ cardId: props.info._id, listId: props.listId, boardId: props.boardId }}
				/>
			)}
		</>
	);
};

export default Card;
